module.exports = __webpack_public_path__ + "img/most-propable.8057ae04.svg";